import { getLocale } from "../runtime";

const sv_bestbefore = /** @type {(inputs?: {}) => string} */ (inputs) => {
	return `Bäst före`
};

const bestbefore = /** @type {(inputs?: {}, options?: {locale?: string}) => string} */ (inputs = {}, options = {}) => {
	const locale = options.locale ?? getLocale();
	if (locale === "sv") return sv_bestbefore(inputs)
	return "bestBefore";
};

export { bestbefore as "bestBefore" };